import React, { useState } from "react";
import { Card, CardBody, Table, Badge } from "reactstrap";
import { formatISOToDDMMYYYY } from "helpers/dateFormat_helper";

import Pagination from "components/Common/Pagination";
import { useDispatch } from "react-redux";
import { fetchStudentProfileRequest } from "store/actions";

const StudentAssignmentCard = ({ data, studentId }) => {
  const dispatch = useDispatch();
  const [pageIndex, setPageIndex] = useState(data?.submissions?.currentPage || 1);

  if (!data) return null;

  const { summary, submissions } = data;
  const totalPages = submissions?.totalPages || 1;
  const totalItems = submissions?.totalSubmissions || 0;

    console.log("🧾 Submissions pagination:", {
    totalItems,
    totalPages,
    currentPage: submissions?.currentPage,
  });

  const handlePageChange = (newPage) => {
    setPageIndex(newPage);
    dispatch(
      fetchStudentProfileRequest(studentId, {
        page: newPage,
        limit: 10,
        status: "reviewed",
      })
    );
  };

  return (
    <Card className="shadow-sm border-0 mb-4">
      <CardBody>
        <h5 className="fw-bold mb-3">Assignments</h5>

        {/* Summary Section */}
        <div className="d-flex flex-wrap gap-4 mb-4">
          <div><strong>Total:</strong> {summary?.totalAssignments}</div>
          <div><strong>Submitted:</strong> {summary?.submittedAssignments}</div>
          <div><strong>Pending:</strong> {summary?.pendingAssignments}</div>
          <div><strong>Reviewed:</strong> {summary?.reviewdAssignments}</div>
        </div>

        {/* Table Section */}
        <div className="table-responsive">
          <Table bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Assignment</th>
                <th>Status</th>
                <th>Marks</th>
                <th>Submitted At</th>
                <th>Reviewed At</th>
                {/* <th>File</th> */}
                <th>Comment</th>
              </tr>
            </thead>
            <tbody>
              {submissions?.list?.length > 0 ? (
                submissions.list.map((item, index) => (
                  <tr key={item._id}>
                    <td>{(pageIndex - 1) * 10 + (index + 1)}</td>
                    <td>{item.assignmentId?.title}</td>
                    <td>
                      <Badge
                        color={
                          item.status === "reviewed"
                            ? "success"
                            : item.status === "pending"
                            ? "warning"
                            : "secondary"
                        }
                      >
                        {item.status}
                      </Badge>
                    </td>
                    <td>{item.marks ?? "-"}</td>
                    <td>
                      {item.submittedAt
                        ? formatISOToDDMMYYYY(item.submittedAt)
                        : "-"}
                    </td>
                    <td>
                      {item.reviewedAt
                        ? formatISOToDDMMYYYY(item.reviewedAt)
                        : "-"}
                    </td>
                    {/* <td>
                      {item.submissionFiles?.length > 0 ? (
                        <a
                          href={item.submissionFiles[0].fileUrl}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {item.submissionFiles[0].name}
                        </a>
                      ) : (
                        "-"
                      )}
                    </td> */}
                    <td>{item.comment || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No submissions found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        {/* Pagination */}
        {totalItems >= 1 && (
          <Pagination
            currentPage={pageIndex}
            totalPages={totalPages}
            totalItems={totalItems}
            pageSize={10}
            onPageChange={handlePageChange}
            showInfo
          />
        )}
      </CardBody>
    </Card>
  );
};

export default StudentAssignmentCard;
